import { useHistory } from 'react-router';

import { useCurrentuser } from '@uplift/contexts';
import { useProviderActivationEvents } from '@uplift/queries';

import { WELCOME_VIDEO_URL } from './constants';
import { getActiveStep } from './helpers';
import { DashboardModal, LiveShowConfettiModal, WelcomeProviderModal } from './pages';
import { OnboardingSteps } from './types';
import { useOnboardingEventActions } from './useOnboardingEventActions.hook';

export const ProviderOnboardingDashboard: React.VFC = () => {
  const history = useHistory();
  const user = useCurrentuser();
  const { data: events, isLoading: eventsIsLoading } = useProviderActivationEvents(user?.id);
  const { welcomeVideoWatched, confettiDisplayed } = useOnboardingEventActions(user?.id);


  const handleGoToDashboardClick = () => {
    confettiDisplayed();
    history.push('/main');
  };

  if (eventsIsLoading) return null;
  const activeStep = getActiveStep(events);

  switch (activeStep) {
    case OnboardingSteps.Welcome:
      return <WelcomeProviderModal videoUrl={WELCOME_VIDEO_URL} handleClick={welcomeVideoWatched} />;
    case OnboardingSteps.ToDo:
    case OnboardingSteps.InReview:
    case OnboardingSteps.Approved:
      return <DashboardModal />;
    case OnboardingSteps.Live:
      return <LiveShowConfettiModal isMobile={false} handleClick={handleGoToDashboardClick} />;
    default:
      return null;
  }
};
